module.exports = __webpack_public_path__ + "media/img/pages/companies/centris-7fb0a67838730d948fe4a4005b4c0ed7.png";